<template>
  <v-dialog v-model="dialog" width="1000px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>{{ step === 'import' ? 'NHẬP EXCEL ĐỐI SOÁT' : 'KẾT QUẢ ĐỐI SOÁT' }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <div
          class="d-flex flex-column justify-center align-center mx-auto"
          style="width: 330px; min-height: 320px"
          v-if="step === 'import'"
        >
          <v-img max-width="100px" max-height="100px" contain src="@/assets/upload-file.svg"></v-img>
          <div class="text-center content-text mt-5" @click="exportExcelTemplate">
            Tải tệp Excel (.xlsx) chứa thông tin đối soát
          </div>
          <div class="mt-5">
            <v-btn color="primary" class="mr-5" @click="exportExcelTemplate" outlined>Tải mẫu nhập</v-btn>
            <v-btn color="primary" class="elevation-0 white--text" :loading="isSelecting" @click="onExcelUpload">
              <span class="white--text">Chọn tệp</span>
              <input
                ref="uploader"
                type="file"
                class="d-none"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="onFileChanged"
              />
            </v-btn>
          </div>
        </div>
        <div v-else>
          <div class="mt-4">
            <v-checkbox
              v-if="step !== 'done'"
              v-model="sendNoti"
              label="Gửi thông báo cho phụ huynh học sinh"
            ></v-checkbox>
            <TableVerifyExcel :data="data" :step="step" />
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" color="primary" outlined light @click="cancel">{{
          step === 'done' ? 'Đóng' : 'Huỷ'
        }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="step === 'send'" color="primary" width="100px" class="elevation-0" @click="confirm"
          >Xác nhận</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import readXlsxFile from 'read-excel-file'
import TableVerifyExcel from './TableVerifyExcel.vue'
import { TuitionFeeReport } from '@/plugins/api'
import { mapActions, mapGetters } from 'vuex'
const schema = {
  'Số tiền': {
    prop: 'amountMoney',
    type: String,
  },
  'Nội dung chuyển khoản': {
    prop: 'reference',
    type: String,
  },
}
export default {
  components: { TableVerifyExcel },
  data() {
    return {
      dialog: false,
      step: 'import',
      isSelecting: false,
      sendNoti: false,
      selectedFile: null,
      data: [],
    }
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
    }),
  },
  methods: {
    ...mapActions({
      upload: 'upload/upload',
    }),
    openDialog() {
      this.step = 'import'
      this.data = []
      this.dialog = true
    },
    cancel() {
      this.$emit('cancel')
      this.dialog = false
    },
    async confirm() {
      try {
        this.$loading.active = true
        let formData = new FormData()
        formData.append('files', this.selectedFile)
        formData.append('source', 's3')
        formData.append('field', 'file')
        const url = await this.upload(formData)
        const data = await TuitionFeeReport.feeReconciliation({
          period: this.detailPeriod._id,
          data: this.data.map(item => {
            item.amountMoney = Number(item.amountMoney)
            return item
          }),
          sendNoti: this.sendNoti,
          urlFile: url,
        })
        this.data = data
        this.step = 'done'
        this.$alert.success('Đối soát học phí thành công')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    exportExcelTemplate() {
      this.$loading.active = true
      window.location.href = `${window.location.origin}/Đối soát học phí.xlsx`
      this.$loading.active = false
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.data = []
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema,
        })
      } catch (error) {
        this.$alert.error({
          title: 'File không có định dạng.',
          description: 'xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)',
        })
        this.$loading.active = false
        return
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        results.forEach(item => {
          item.amountMoney = `${item.amountMoney}`.replace(/,/g, '')
        })
        this.data = results
        this.step = 'send'
      }
      this.$loading.active = false
    },
  },
}
</script>

<style></style>
